/* Parts of this file are used in more than one place, so it's trickier to split this out of the application bundle */

// DRY VIOLATION WARNING: this regex also lives in config/initializers/devise.rb
const EMAIL_REGEX = // for validating (well, sanity-checking) email addresses
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

$.prototype.b_datepicker = function(args) {
  return this.datepicker(_(args||{}).defaults(
    {format:"yyyy-mm-dd", firstDay:1, changeMonth:true, changeYear:true}))
}

$(document).ready(function() {
  $(".modal-dialog:not(.nondraggy)").draggable()
  /* trigger hide/show password for all user password fields */
  $("#signup_user_password, #login_user_password, .edit_user #user_password").hideShowPassword({
    show: false,
    innerToggle: true,
    toggle: {
      offset: "-5px",
      attr: {
        role: 'button',
        'aria-label': 'Show Password',
        title: 'Show Password',
        tabIndex: -1
      }
    },
    wrapper: {
    styles: { 
      width: "100%",
      position: "relative",
      display: "block",
      "vertical-align": "baseline",
      margin: "0px" 
    },
    }
  })
    .on('passwordShown', function(evt) {
      console.log("target id", evt.target.id)
    $(`#${evt.target.id}_confirmation`).showPassword();
  })
    .on('passwordHidden', function(evt) {
    $(`#${evt.target.id}_confirmation`).hidePassword();
  });

  // add a validator method where you check the value entered against
  // a simple md5 checksum in a data attribute called "answer" on the input
  $.validator.addMethod("checksum", function(value, element) {
    return beetils.md5(value.trim().toLowerCase()) === $(element).data("answer")
  }, "The answer is not correct!")
  $.validator.addMethod("matches", function(value, element, params) {
    return params.test(value) 
  }, "The field must match");
  $.validator.methods.email = function( value, element ) {
    return this.optional( element ) || EMAIL_REGEX.test( value.trim() );
  }

////////////////////////////////////////////////////////////////////////////////
//-- Registration form validations & credit card binding
//
if ($("#signup_new_user").length > 0) {
  // Validate the user signup form in realtime
  $("#signup_new_user").validate({
    submitHandler: function(form, evt) {
      //smart submit that (i.e. disable the submit button once you push go)
      //do it here so we don't have to handle re-enabling it if the validation
      //fails and then is corrected
      //this validation plugin is already handling the part where it doesn't
      //actually submit the form until the whole thing says it is valid.
      $(form).find(":submit").prop("disabled",true);
      form.submit();
    },
    onkeyup: function(elt, evt) {
      if ($(elt).valid()) {
        //$("#signup_new_user button:submit").removeProp("disabled")
        $(elt).removeClass("is-invalid");
      }
      return true
    },
    errorClass: "is-invalid",
    validClass: "is-valid",
    rules: {
      "user[username]": {
        required: true,
        alphanumeric: true,
        maxlength: 20,
        remote: "/api/private/usernames.json",
        },
      "user[email]": {
        required: true,
        email: true,
        remote: "/api/private/emails.json",
      },
      "user[password]": "required",
      "user[intentions]": {
        maxlength: 280,
        matches: /\$5/,
      },
      "user[human_check]": {
        required: true,
        checksum: true,
      },
      "stripeId": {}
    },
    messages: {
      "user[username]": {
        remote: "Username is taken or reserved",
      },
      "user[email]": {
        remote: "Email is taken",
        email: "Please enter a valid email address",
        /*
        function(val,elt) {
          let addr = $(elt).val()
          if (addr === $.trim(addr)) {
            return "Please enter a valid email address"
          } else {
            return "Do you have a leading or trailing space?"
          }
        },
        */
      },
      "user[intentions]": {
        matches: "Please use the literal string '$5' as part of your explicit consent to the meta commitment device."
      }
    }
  })
}
//-- End of Registration form validations & credit card binding
////////////////////////////////////////////////////////////////////////////////

  //-- begin things for adding a payment method and presenting the hook check modal --//

// TODO STRIPE a bunch of this "update the cc page & show infinibee etc" stuff 
// in add-cc function is probably moot with the stripe-checkout-redirect.
  // Where is this used? elf, signup, backcharges...
  $(".add-cc").click(function(e) {
    e.preventDefault();
    $(".trial-banner #add-text").hide();
    $(".trial-banner #loading-text").show();

    // get the api/private/stripe_setup/checkout endpoint
    // and redirect to the URL
    function success(data) {
      $(".trial-banner").hide();
      $('#pick-payment').modal("hide");
      if (beemApi.golCount > 0 && $("#hook-check").length > 0) {
      // if they've got goals already, show them hookcheck
        $("#hook-check").modal();
      }
      // TODO: this should be refactored because it is weird that this 
      // elf functionality is split over here into the newbee.js file
      // it ought to live where it is used, not here.
      if ($(".elf #payment").length > 0) {
        // in this case we're doing this during goal creation
        beetils.hideInfinibee("stripe")
        $("#payment .step1").hide();
        $("#payment .step2").show();  
        $(".step2 .card").append("**** **** **** "+data.stripe.last4);
        if (beemApi.golCount == 0) {
          // only click the submit if we're not showing them hookcheck
          // TODO: maybe remove this? why would we click it for them??
          $("#payment-continue").click();
        }
      }
      if ($("#payment-methods").length > 0) {
        beetils.hideInfinibee("stripe")
        var card_div = $(".paytype .stripe")
        if (card_div.length == 0) {
          var defcheck = $(".paytype .defaults").remove()
          card_div = $("<div></div>", {
            class: "stripe card"
          }).append($("<div></div>", {
            class: "card-row last4"
          })).append($("<div></div>", {
            class: "card-row details"
          })).append($("<div></div>", {
            class: "card-row expiry"
          }))
          $(".paytype").first().append(card_div).append(defcheck.removeClass("hidden"))
        }
        $(".paytype .stripe .last4").text("**** **** **** "+data.stripe.last4)
        $(".paytype .stripe .details").text(data.stripe.name)
        $(".paytype .stripe .expiry").text("Valid until "+data.stripe.exp_year+"/"+data.stripe.exp_month)
      }
    }
    function error(data) {
      beetils.hideInfinibee("stripe")
    }
    $.ajax({
      type: "GET",
      url: "/api/private/stripe_checkout.json?access_token="+beetils.tokenParams().access_token+
      "&checkout=setup",
      success: function(data) {
        console.log("SUCCESS DATA", data)
        $(location).attr('href', data.redirect_url)
      },
      error: function() {
        error()
      }
    });

  });

  $("#hook-check").on("hidden.bs.modal", function() {
    if ($(".elf #payment").length === 0) {
      location.reload();
    }
  });

  //-- end things for adding a payment method and presenting the hook check modal --//

  $(".progsum .tiny").tooltip();

  // initiate tooltips on tipable
  $('.tipable').tooltip({});

  // bind copyable
  // add .copyable to an element and .tipable and either data-referent refering to another element to copy the contents of, or data-copy containing the actual text to copy and we will do nice popup and click-to-copy things
  $(".copyable").click(function(e) {
    e.preventDefault()
    __this = $(this)
    var otitle = __this.data("original-title")
    var text = ""
    if (__this.data("referent")) 
    {
      text = $.trim($("#"+__this.data("referent")).text())
    } 
    else if (__this.data("copy"))
    {
      text = $.trim(__this.data("copy"))
    }
    var temp = $("<input>")
    $("body").append(temp)
    temp.val(text).select()
    document.execCommand("copy")
    __this.attr("title", "Copied!")
    __this.data("bs.tooltip")._fixTitle()
    __this.tooltip("show")
    temp.remove()
    // set an event handler to fire once the next time this tooltip is
    // hidden and replace the tooltip with the original tooltip text
    __this.one('hidden.bs.tooltip', function () {
      __this.attr("title", otitle)
      __this.data("bs.tooltip")._fixTitle()
    })
  });

  // bind smart submit
  $("form.smart-submit").submit(function() {
    if ($(this).find("input.required[type='checkbox']:unchecked").length)
      return false
    $(this).find(":submit").prop("disabled",true);
  });
  $("a.smart-submit").click(function() {$(this).prop("disabled",true)});
  // end smart submit

  var bindVerifyUnsubmit = function() {
    var setConfirmUnload = function(on,message) {
      message = (typeof message !== 'undefined') ? message :
        "If you leave this page without saving your changes they will be lost"
      window.onbeforeunload = on ?
        function(e){
          e.returnValue = message;
          return message;
        } : null;
    };
    $('form.verify-unsubmit').each(function(i, form) {
      var ffm = $(form);
      var orig_form = ffm.serialize();
      var msg = ffm.data("unsubmit");
      ffm.on('change keyup', function(e) {
        var has_file = ffm.find("input[type='file']").length > 0
        if(ffm.serialize() === orig_form && !has_file) {
          setConfirmUnload(false);
        }
        else if(e["keyCode"] !== 13) {
          setConfirmUnload(true,msg);
          $(':submit',ffm).removeAttr('disabled')
        }
        else if( e["keyCode"] === 13) {
        }
      });
      ffm.submit(function() { setConfirmUnload(false); });
    })
  }
  bindVerifyUnsubmit();

  // convert rails flash to js flash
  function convertFlash() {
    var fCont = $("#flash .flash_container");
    var fullMsg = $.trim(fCont.html());
    var trimMsg = $.trim(fCont.text());
    var flashType = "notice";
    if (fCont.hasClass("flash-success")) {
      flashType = "success";
    }
    if (fCont.hasClass("flash-error")) {
      flashType = "error";
    }
    if (trimMsg.length > 0) {
      beetils.showFlash(flashType, fullMsg, true);
    }
    if (trimMsg.length > 80) {
      $("#flash-js .message").addClass("long")
    }
  }

  convertFlash();

  /*TODOBEE: gimmefree & glimit refactoring*/
  /* give me more free goals button when user hits their glimit */
  if ($('.gimmefree').length) {
    var success_dismiss = function(data) {
      $('#gimmefree-modal').modal('hide');
      beetils.showFlash("success", 
        "Got your message! We'll contact you shortly.")
    }
    var error_show = function(data) {
      $('#gimmefree-modal').modal('hide')
      $('.gimmefree').prop('disabled',false)
      beetils.showFlash("error", "Something went wrong. I am baffled.")
    }
    var gimmefree_submit = function(params, success, error) {
      if (beemApi.currentUsername) {
        $(this).prop('disabled',true)
        $.ajax({
          type:    "POST",
          url:     "/api/private/gimmefreestuff",
          data:    $.extend(beetils.tokenParams(), params),
          success: success,
          error:   error,
        })
      } else {
        $('#gimmefree-modal').modal('show')
      }
    }
    $('.gimmefree').click(function(){
      $(this).prop('disabled', true)
      gimmefree_submit({
        button: $(this).attr("data-gimme"),
        comment: $('#gimmefree_comments').val(),
      }, success_dismiss, error_show)
    })
  }

  // send the browser time zone back when creating the user
  if($("#signup_new_user #signup_user_timezone").length > 0) {  
    if ($("#signup_new_user #tzguess").length === 0 ||
        $("#signup_new_user #tzguess").val() === "" ||
        $("#signup_new_user #tzguess").val() ===  undefined) {
      $("#signup_new_user #signup_user_timezone").val(mapZone(moment.tz.guess())); 
    }

function mapZone(zone) {
 return {"Pacific/Midway":"Midway Island","Pacific/Pago_Pago":"American Samoa","Pacific/Honolulu":"Hawaii","America/Juneau":"Alaska","America/Los_Angeles":"Pacific Time (US \u0026 Canada)","America/Tijuana":"Tijuana","America/Denver":"Mountain Time (US \u0026 Canada)","America/Phoenix":"Arizona","America/Chihuahua":"Chihuahua","America/Mazatlan":"Mazatlan","America/Chicago":"Central Time (US \u0026 Canada)","America/Regina":"Saskatchewan","America/Mexico_City":"Mexico City","America/Monterrey":"Monterrey","America/Guatemala":"Central America","America/New_York":"Eastern Time (US \u0026 Canada)","America/Indiana/Indianapolis":"Indiana (East)","America/Bogota":"Bogota","America/Lima":"Quito","America/Halifax":"Atlantic Time (Canada)","America/Caracas":"Caracas","America/La_Paz":"La Paz","America/Santiago":"Santiago","America/St_Johns":"Newfoundland","America/Sao_Paulo":"Brasilia","America/Argentina/Buenos_Aires":"Buenos Aires","America/Montevideo":"Montevideo","America/Guyana":"Georgetown","America/Godthab":"Greenland","Atlantic/South_Georgia":"Mid-Atlantic","Atlantic/Azores":"Azores","Atlantic/Cape_Verde":"Cape Verde Is.","Europe/Dublin":"Dublin","Europe/London":"London","Europe/Lisbon":"Lisbon","Africa/Casablanca":"Casablanca","Africa/Monrovia":"Monrovia","Etc/UTC":"UTC","Europe/Belgrade":"Belgrade","Europe/Bratislava":"Bratislava","Europe/Budapest":"Budapest","Europe/Ljubljana":"Ljubljana","Europe/Prague":"Prague","Europe/Sarajevo":"Sarajevo","Europe/Skopje":"Skopje","Europe/Warsaw":"Warsaw","Europe/Zagreb":"Zagreb","Europe/Brussels":"Brussels","Europe/Copenhagen":"Copenhagen","Europe/Madrid":"Madrid","Europe/Paris":"Paris","Europe/Amsterdam":"Amsterdam","Europe/Berlin":"Bern","Europe/Rome":"Rome","Europe/Stockholm":"Stockholm","Europe/Vienna":"Vienna","Africa/Algiers":"West Central Africa","Europe/Bucharest":"Bucharest","Africa/Cairo":"Cairo","Europe/Helsinki":"Helsinki","Europe/Kiev":"Kyiv","Europe/Riga":"Riga","Europe/Sofia":"Sofia","Europe/Tallinn":"Tallinn","Europe/Vilnius":"Vilnius","Europe/Athens":"Athens","Europe/Istanbul":"Istanbul","Europe/Minsk":"Minsk","Asia/Jerusalem":"Jerusalem","Africa/Harare":"Harare","Africa/Johannesburg":"Pretoria","Europe/Moscow":"Volgograd","Asia/Kuwait":"Kuwait","Asia/Riyadh":"Riyadh","Africa/Nairobi":"Nairobi","Asia/Baghdad":"Baghdad","Asia/Tehran":"Tehran","Asia/Muscat":"Muscat","Asia/Baku":"Baku","Asia/Tbilisi":"Tbilisi","Asia/Yerevan":"Yerevan","Asia/Kabul":"Kabul","Asia/Yekaterinburg":"Ekaterinburg","Asia/Karachi":"Karachi","Asia/Tashkent":"Tashkent","Asia/Kolkata":"New Delhi","Asia/Kathmandu":"Kathmandu","Asia/Dhaka":"Dhaka","Asia/Colombo":"Sri Jayawardenepura","Asia/Almaty":"Almaty","Asia/Novosibirsk":"Novosibirsk","Asia/Rangoon":"Rangoon","Asia/Bangkok":"Hanoi","Asia/Jakarta":"Jakarta","Asia/Krasnoyarsk":"Krasnoyarsk","Asia/Shanghai":"Beijing","Asia/Chongqing":"Chongqing","Asia/Hong_Kong":"Hong Kong","Asia/Urumqi":"Urumqi","Asia/Kuala_Lumpur":"Kuala Lumpur","Asia/Singapore":"Singapore","Asia/Taipei":"Taipei","Australia/Perth":"Perth","Asia/Irkutsk":"Irkutsk","Asia/Ulaanbaatar":"Ulaanbaatar","Asia/Seoul":"Seoul","Asia/Tokyo":"Tokyo","Asia/Yakutsk":"Yakutsk","Australia/Darwin":"Darwin","Australia/Adelaide":"Adelaide","Australia/Melbourne":"Melbourne","Australia/Sydney":"Sydney","Australia/Brisbane":"Brisbane","Australia/Hobart":"Hobart","Asia/Vladivostok":"Vladivostok","Pacific/Guam":"Guam","Pacific/Port_Moresby":"Port Moresby","Asia/Magadan":"Magadan","Pacific/Guadalcanal":"Solomon Is.","Pacific/Noumea":"New Caledonia","Pacific/Fiji":"Fiji","Asia/Kamchatka":"Kamchatka","Pacific/Majuro":"Marshall Is.","Pacific/Auckland":"Wellington","Pacific/Tongatapu":"Nuku'alofa","Pacific/Fakaofo":"Tokelau Is.","Pacific/Chatham":"Chatham Is.","Pacific/Apia":"Samoa"}[zone]
}
  }
});
